module.exports = (Promise.resolve(__parcel__require__("./" + "Native.84d9e557.236c74ca.js"))).then(() => parcelRequire('giXeg'));